import React, { useEffect, useState } from "react";
import "./safetyHealth.css";
import Search from "../../components/Search";
import api from "../../services/baseUrl";
import { useLibrary } from "../../context/LibraryContext";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const SafetyHealthPage = () => {
  const [sheCategory1Docs, setSheCategory1Docs] = useState([]);
  const [sheCategory2Docs, setSheCategory2Docs] = useState([]);
  const [allSheCategory1Docs, setAllSheCategory1Docs] = useState([]);
  const [allSheCategory2Docs, setAllSheCategory2Docs] = useState([]);
  const { setLibraryId } = useLibrary();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchShe = async () => {
      setLoading(true);
      try {
        const response = await api.post("/api/lawlibrary-documents/she");

        // Split the response data based on sheCategory
        const category1 = response.data.filter((doc) => doc.sheCategory === 1);
        const category2 = response.data.filter((doc) => doc.sheCategory === 2);

        // Set the state for each category
        setSheCategory1Docs(category1);
        setSheCategory2Docs(category2);
        setAllSheCategory1Docs(category1);
        setAllSheCategory2Docs(category2);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchShe();
  }, []);

  const handleDocumentNavigation = (documentId, libraryId) => {
    setLibraryId(libraryId);
    navigate(`/law-library/document?documentID=${documentId}`);
  };

  const handleSearch = (query) => {
    const lowerQuery = query.searchQuery.toLowerCase();

    if (lowerQuery === "") {
      setSheCategory1Docs(allSheCategory1Docs);
      setSheCategory2Docs(allSheCategory2Docs);
    }
    const filteredCat1 = allSheCategory1Docs.filter((doc) =>
      doc.title?.toLowerCase().includes(lowerQuery)
    );

    const filteredCat2 = allSheCategory2Docs.filter((doc) =>
      doc.title?.toLowerCase().includes(lowerQuery)
    );

    setSheCategory1Docs(filteredCat1);
    setSheCategory2Docs(filteredCat2);
  };

  return (
    <div className="safety-container">
      <div className="safety-content">
        <div className="safety-body">
          <Search onSearch={handleSearch} ready={true} isSHE={true} />
        </div>
        {loading ? (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "25px",
              }}
            >
              <CircularProgress />
            </div>
          </>
        ) : (
          <div className="safety-two-table">
            <div className="safety-one-table">
              <p className="safety-blue-row">Safety and Health</p>
              {sheCategory1Docs.map((doc, index) => (
                <p
                  key={doc.id}
                  style={{ cursor: "pointer" }}
                  className={
                    index % 2 === 0 ? "safety-white-row" : "safety-grey-row"
                  }
                  onClick={() => {
                    handleDocumentNavigation(doc.documentID, doc.libraryId);
                  }}
                >
                  {doc.title} {/* Assuming doc has a title property */}
                </p>
              ))}
              {/* <p className="safety-blue-row" style={{ marginTop: 50 }}>
                Another Module
              </p>
              <p className="safety-blue-row" style={{ marginTop: 15 }}>
                Guidelines
              </p>
              <p className="safety-blue-row" style={{ marginTop: 15 }}>
                Code of Practise
              </p> */}
            </div>
            <div className="safety-one-table">
              <p className="safety-blue-row">Environment and Sustainability</p>
              {sheCategory2Docs.map((doc, index) => (
                <p
                  key={doc.id}
                  style={{ cursor: "pointer" }}
                  className={
                    index % 2 === 0 ? "safety-white-row" : "safety-grey-row"
                  }
                  onClick={() => {
                    handleDocumentNavigation(doc.documentID, doc.libraryId);
                  }}
                >
                  {doc.title} {/* Assuming doc has a title property */}
                </p>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SafetyHealthPage;
